import { css, Global } from "@emotion/react";

const global = css`
    * {
        margin: 0;
        padding: 0;
        font-family: "Pretendard Variable";
        border: none;
        box-sizing: border-box;
        ::-webkit-scrollbar {
            display: none;
        }
    }

    ul,
    li {
        list-style: none;
    }

    p {
        line-height: 1.5;
    }
`;

export const GlobalStyles = () => {
    return <Global styles={global} />;
};
